import React from 'react'
import { Button } from '@paypalcorp/pp-react'
import { Input } from '../input'

export const InputList = ({ data, handleOnChange, addRow, removeRow }) => {
  return (
    <>
      {data.map((items, firstIdx) => (
        <div className="dev_dash__input_list--container" key={firstIdx}>
          <div className="dev_dash__input_list--wrapper">
            {items.map((item, secondIdx) => (
              <Input
                key={secondIdx}
                name={item.name}
                value={item.value}
                onChange={(e) => handleOnChange(e, firstIdx, secondIdx)}
                error={item.error}
                errorMessage={
                  item.errorMessage || 'Oauth return url is invalid'
                }
              />
            ))}
          </div>

          <div>
            {firstIdx === data.length - 1 &&
              (data.length > 1 ? (
                <Button secondary size="sm" onClick={addRow}>
                  +
                </Button>
              ) : (
                <Button size="sm" onClick={addRow}>
                  +
                </Button>
              ))}
            {data.length > 1 && (
              <Button secondary size="sm" onClick={removeRow}>
                -
              </Button>
            )}
          </div>
        </div>
      ))}
    </>
  )
}
